<script>
    export let conditionalKey = '';
    export let row = {};
    export let conditionalActions = {};
    export let actions = {}
    export let conditionalValue = true;
    export let showActionLabel = false;
</script>

<style>
</style>

<div class="actions d-flex flex-nowrap justify-content-end">
  {#each Object.keys(actions) as k}
      <button class="btn btn-sm btn-outline ml-1" on:click={(event) => actions[k].handler(event, row)}>
          <i class={actions[k].iconClass}/>
          {#if showActionLabel}
              {actions[k].label}
          {/if}
      </button>
  {/each}
  {#if conditionalKey in row && row[conditionalKey] == conditionalValue}
      {#each Object.keys(conditionalActions) as k}
          <button class="btn btn-sm btn-outline ml-1" on:click={(event) => conditionalActions[k].handler(event, row)}>
              <i class={conditionalActions[k].iconClass}/>
              {#if showActionLabel}
                  {conditionalActions[k].label}
              {/if}
          </button>
      {/each}
  {/if}
</div>
